import { fetch } from "../config/fetch";
import { getAccessToken } from "../utils";
import axios from "axios";

export const LoginApp = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/login",
    headers: {
      Authorization: getAccessToken(),
    },
  };
  return fetch(options);
};

export const LogoutApp = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: "/user/logout",
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const checkUsername = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/check_username",
  };
  return fetch(options);
};

export const checkUsernameReward = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/check_username",
  };
  return fetch(options);
};

export const getUserProfile = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: "/profile",
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const getAllJourneyData = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: "/journey",
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const resetPassword = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/recover_password_email",
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const getListCourse = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/journey/${opt}/course`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const getListModule = (opt1, opt2) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/journey/${opt1}/course/${opt2}/module`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const getListModuleSupport = (opt1, opt2) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/journey/${opt1}/course/${opt2}/module_support`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const changePassword = (opt, token) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/user/password",
    headers: {
      TOKEN: token,
    },
  };
  return fetch(options);
};

export const verifyOTP = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/otp_verification",
  };
  return fetch(options);
};

export const getDetailModule = (opt1, opt2, opt3) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/journey/${opt1}/course/${opt2}/module/${opt3}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const changePhotoProfile = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/user/upload",
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const detailProfile = (opt) => {
  const options = {
    method: "GET",
    url: `/profile/${opt}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getAchievements = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: "/profile/achievement",
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getAchievementsById = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/profile/achievementById/${opt}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getAdditional = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/additional_learning/${opt}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getCertificate = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: "/getCertif",
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getCertificateById = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/getCertifById?user_id=${opt}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const submitRating = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/rating/submit",
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const checkHasRatingModule = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/check_rating/${opt}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const checkGotBadges = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: `/achievement/check_badge`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const claimPoint = (opt1, opt2) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/achievement/${opt1}/${opt2}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const streamModule = (opt1, opt2) => {
  const options = {
    ...opt1,
    method: "POST",
    url: `/v2/stream-module/${opt1}/${opt2}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const completionModule = (opt1) => {
  const options = {
    ...opt1,
    method: "POST",
    url: `/journey/completion`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const getOverview = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: "/team/monitoring/overview",
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getTeamStatus = (opt, isMobileVersion) => {
  const options = {
    ...opt,
    method: "GET",
    url: isMobileVersion
      ? "/team/monitoring/detail"
      : `/team/monitoring/team_status`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const selectedPrograms = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/team/monitoring/detail${opt}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getListEvent = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: "/team/monitoring/event",
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getEventCalendar = (opt1, opt2) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/team/monitoring/event_calendar?start_date=${opt1}&end_date=${opt2}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getEventDetail = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/team/monitoring/event/${opt}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getContentLibrary = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: "/content_library_web",
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getListProgramAcademy = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/content_library_program/${opt}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getCollectionLibrary = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/content_library_collection${opt}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const addCollectionLibrary = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/content_library_collection",
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const deleteCollectionLibrary = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/delete_collection",
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const getListCourseContentLibrary = (opt, opt2) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/content_library/${opt}/journey/${opt2}/course_content_library`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const getListModuleContentLibrary = (opt1, opt2, opt3) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/content_library/${opt1}/journey/${opt2}/course/${opt3}/module_content_library`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const getListModuleSupportContentLibrary = (opt1, opt2, opt3) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/content_library/${opt1}/journey/${opt2}/course/${opt3}/module_support_content_library`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const getModuleReviewed = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    // url: `/review/module`,
    url: `/reviews-module-list`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getListUserReviewed = (opt1, opt2) => {
  const options = {
    ...opt1,
    method: "GET",
    // url: `/review/module_web/${opt1}/${opt2}`,
    url: `/reviews-detail/${opt1}/${opt2}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getModuleReviewedDetail = (opt1, opt2, opt3) => {
  const options = {
    ...opt1,
    method: "GET",
    // url: `/review/module_web/${opt1}/${opt2}`,
    url: `/answers/${opt1}/${opt2}/${opt3}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getCurrModuleReviewed = (opt1, opt2) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/review/module_user/${opt1}/${opt2}/web`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const submitReviewPost = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/review/submit",
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const reviewSubmit = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/submit-reviews",
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const deleteModuleReview = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/delete-reviews",
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getNotification = (opt1) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/notification/get_data?type=${opt1}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const updateNotificationFlag = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/notification",
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const getPointHistory = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/point-history`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getAllRewards = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/gamification/journey_reward/0`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getDetailRewards = (opt1) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/gamification/reward/detail/${opt1}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const redeemReward = (opt1) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/gamification/redeem_reward_web/${opt1}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getRewardsHistory = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/gamification/reward_history/0`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getAllLeaderboards = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/journey/leaderboard",
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const getAllEnrolledProgram = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/all-enrolled-program`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getUserEvent = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/all-event`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getDetailUserEvent = (opt1) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/detail-event/${opt1}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getSearch = (opt1) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/search${opt1}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getSearchDetail = (opt1) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/search-detail${opt1}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getModuleImageCL = (opt1) => {
  const options = {
    ...opt1,
    method: "POST",
    url: `/get-module-image`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const getQRCodeData = (opt1) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/attendance/${opt1}/web`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const getCompletedJourneyProfile = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/completion-program-profile`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const getListUserAttendance = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/learner-list/${opt}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };

  return fetch(options);
};

export const submitCheckinAttendance = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/manual-attendance",
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const checkIsCompleteAttendance = (opt1) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/success-check-in/${opt1}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const getCertifPopup = (opt1, opt2, opt3) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/multi-certif/${opt1}/${opt2}/${opt3}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const FetchAutoLogin = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/auto-login-token",
    headers: {
      Authorization: getAccessToken(),
    },
  };
  return fetch(options);
};

export const FetchProgramByProgramUUID = (opt) => {
  const options = {
    ...opt,
    method: "GET",
    url: `/journey/${opt}`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const getListSidebar = (opt1) => {
  const options = {
    ...opt1,
    method: "GET",
    url: `/menu_list`,
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const PostDataScorm = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/v2/module/scorm_track",
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};

export const GetDataScorm = (opt) => {
  const options = {
    ...opt,
    method: "POST",
    url: "/v2/module/scorm_get",
    headers: {
      TOKEN: getAccessToken(),
    },
  };
  return fetch(options);
};